import { Box, Typography } from '@mui/material';

export function PageHeader({ title, subtitle }) {
  return (
    <Box
      sx={{
        mb: 3,
        pl: 2,
        borderLeft: '4px solid #284B32',
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, color: '#284B32', lineHeight: 1.2 }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
